/** Common interface for header navigation */
export interface NavigationEntity {
  id: string;
  label?: string | null;
}

/** Contains all logged in user vacation trip content */
export interface Vacation {
  deltaVacationTitle: string;
  viewTripDetailsTitle: string;
  checkInTitle: string;
  viewAllTripsTitle: string;
  findMyTripsTitle: string;
  hotelReservationTitle: string;
  viewBoardingPassTitle: string;
}

/** Contains all logged in user car reservation content */
export interface CarReservation {
  carReservationTitle: string;
  viewTripDetailsTitle: string;
  checkInTitle: string;
  viewAllTripsTitle: string;
  findMyTripsTitle: string;
  hotelReservationTitle: string;
  viewBoardingPassTitle: string;
}

/** Contains all logged in user trip content */
export interface UpComingtTrips {
  upComingTripTitle: string;
  viewTripDetailsTitle: string;
  checkInTitle: string;
  viewAllTripsTitle: string;
  findMyTripsTitle: string;
  hotelReservationTitle: string;
  viewBoardingPassTitle: string;
}

/** Holds all trip content that display when user is logged in and click "MY TRIPS" Primary Navigation on header */
export interface MytripsLoggedIn {
  vacation: Vacation;
  carReservation: CarReservation;
  upComingtTrips: UpComingtTrips;
}

/** Holds input label that display in "MY TRIP" Primary Navigation on header */
export interface MytripsEntity {
  mytripsSearchByTitle: string;
  mytripsSearchById: string;
  mytripSearchByNumber: string;
  searchTripsFloatLabel: string;
  mytripSearchByType: string;
}

/** Holds input label that display in "CHECK-IN" Primary Navigation on header */
export interface CheckInEntity {
  title: string;
  value: string;
  trackingNumber: string;
  trackingNumberType: string;
  searchFloatLabelCheck: string;
}

/** Holds Trip Type information that appears in  dropdown of "BOOK" navigation on header  E.g., "ROUND TRIP", "ONE WAY", "MULTI CITY" */
export interface TripTypeEntity {
  tripTypeTitle: string;
  tripTypeValue: string;
}

/** Holds Passenger information that appears in Passenger dropdown of "BOOK" navigation on header  */
export interface PassengersEntity {
  passengerId?: string;
  passengerTitle?: string;
}

/** Holds toop tip information of all input fields that appears in primary navigation */
export interface ToolTipDetailsEntity {
  itemId: string;
  toolTipType: string;
  toolTipTitle?: string | null;
  toolTipDescription?: string | null;
  toolTipExternalLink?: string | null;
  openinnewTab?: string | null;
}

/** Salution information that display on "MY FLIGHT" auxilary navigation on header  */
export interface SalutationEntity {
  /** E.g goodMorning */
  salutationId: string;
  /** E.g Good Morning */
  salutationLabel: string;
}

/** Medallion information that display on "MY FLIGHT" auxilary navigation on header  E.g., "Gold Medallion", "Silver Medallion" */
export interface MedallionEntity {
  medallionId?: string;
  medallionLabel?: string;
  medallionUrl?: string;
  medallionMessage?: string;
}

/** Program Waiver information that display on "MY FLIGHT" auxilary navigation on header  */
export interface WaiverEntity {
  waiverLabel: string;
  waiverUrl: string;
  waiverPrice: string;
}

/** Holds content of Popular topics that display on "Search Feed" auxilary navigation on header E.g., "Need Help", "Face Mask" */
export interface PopularTopicsEntity {
  populartopicsTitle: string;
  populartopicsLink: string;
  openinnewTab: string;
}

/** Holds image link of interstitial banner */
export interface ImageListEntity {
  deskImage: string;
  mobileImage: string;
}
